import { render, staticRenderFns } from "./uni-login.vue?vue&type=template&id=386306ef&"
import script from "./uni-login.vue?vue&type=script&lang=js&"
export * from "./uni-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports